import Vue from "vue";
import Vuex from "vuex";

import { getRoleList, getDefaultRole, apiGetUserInfo } from "@/api/user";
import { apiKfInit, getGlobalNotice, apiKfIndex } from "@/api/Im";
import getters from "./getters";
// import { getItem } from '@/utils/storage';
// import im from '@/views/im/modules/im';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    roleList: [],
    defaultRoleInfo: { id: "tourist" },
    userInfo: {},
    vuexInitData: {},
    globalNotice: null,
    indexData: {},
  },
  mutations: {
    SET_INIT: (state, info) => {
      state.vuexInitData = info;
    },
    SET_ROLE_LIST: (state, roleList) => {
      state.roleList = roleList;
    },
    SET_DEFAULT_ROLE_INFO: (state, defaultRoleInfo) => {
      state.defaultRoleInfo = defaultRoleInfo;
    },
    SET_USERINFO: (state, info) => {
      state.userInfo = info;
    },
    SET_GLOBAL_NOTICE: (state, info) => {
      state.globalNotice = info;
    },
    SET_INDEX_DATA: (state, info) => {
      state.indexData = info;
    },
  },
  actions: {
    getRoleList({ commit }, info) {
      return new Promise((resolve, reject) => {
        getRoleList(info)
          .then((res) => {
            if (res.code === 0) {
              commit("SET_ROLE_LIST", res.data || []);
              const current = res.data.find((item) => item.is_default === 1);
              commit("SET_DEFAULT_ROLE_INFO", current || { id: "tourist" });
            }
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // getDefaultRoleInfo({commit}, info = {}) {
    //   return new Promise((resolve, reject) => {
    //     getDefaultRole(info).then(res => {
    //       if (res.code === 0) {
    //         commit('SET_DEFAULT_ROLE_INFO', res.data || {});
    //       }
    //       resolve(res);
    //     }).catch(err => {
    //       reject(err);
    //     });
    //   });
    // },
    //用户信息
    getUserInfo({ state, commit }) {
      return new Promise((resolve, reject) => {
        apiGetUserInfo()
          .then((res) => {
            console.log("getUserInfo", res);
            if (res.code === 0) {
              commit("SET_USERINFO", res.data);
              resolve(res.data);
            } else {
              reject(res);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // 检查登录状态
    checkLogin({ state, dispatch }, isToRole = false) {
      return new Promise((resolve, reject) => {
        const token = localStorage.getItem("token");
        const role = state.defaultRoleInfo;

        if (!token) {
          reject();
        } else {
          let strings = token.split(".");
          let loginUser = {};
          try {
            loginUser = JSON.parse(
              decodeURIComponent(
                window.atob(strings[1].replace(/-/g, "+").replace(/_/g, "/"))
              )
            );
          } catch (e) {
            loginUser = {};
          }

          if (
            state.vuexInitData.game_extra_config.guest_login_enabled &&
            loginUser.user.login_type === -1
          ) {
            reject();
            return;
          }

          if (state.userInfo && state.userInfo.id) {
            resolve();
          } else {
            dispatch("getUserInfo")
              .then(() => {
                resolve();
              })
              .catch((err) => {
                reject();
              });
          }
        }
      });
    },
    //  初始化信息
    getKfInit({ state, commit }) {
      return new Promise((resolve, reject) => {
        apiKfInit()
          .then((res) => {
            if (res.code === 0) {
              if (window.staticFn && res.data.user_info) {
                window.staticFn.setConfig({ uid: res.data.user_info.id });
              }
              commit("SET_INIT", res.data);
              resolve(res.data);
            }
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // index数据
    getIndexData({ state, commit }) {
      return new Promise((resolve, reject) => {
        apiKfIndex()
          .then((res) => {
            if (res.code === 0) {
              sessionStorage.setItem(
                "gameInfo",
                JSON.stringify(res.data.chat_game)
              );
              commit("SET_INDEX_DATA", res.data);
              resolve(res.data);
            } else {
              // console.log("indexData", res);
              reject(res);
            }
          })
          .catch((err) => {
            reject(err);
            return false;
          });
      });
    },
    // 获取全局公告
    getGlobalNotice({ commit }, info = {}) {
      return new Promise((resolve, reject) => {
        getGlobalNotice(info)
          .then((res) => {
            if (res.code === 0) {
              commit("SET_GLOBAL_NOTICE", res.data || null);
            }
            console.log("notice", res);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  modules: {},
  getters,
});
